export const REQUESTS_LIMIT = 5;

export const LEAVE_REQUESTS_LINK = '/ess/manage-requests/leave-request';
